define('views/lib/Podio.Views.SubmitToggler',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Tooltips','lib/Podio.Browser','lib/Podio.UI','jst!lib/_submit_toggler'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var tooltips = require('lib/Podio.UI.Tooltips');
  var podioBrowser = require('lib/Podio.Browser');
  var podioUI = require('lib/Podio.UI');

  var jstSubmitToggler = require('jst!lib/_submit_toggler');

  return PodioView.extend({

    podioEvents : {
      'click .submit-toggler-submit'          : 'onSubmitButtonClicked',
      'change default .submit-toggler-toggle' : 'onSubmitToggleChanged'
    },

    initialize: function(options) {
      this._super();

      this.isToggled = this.options.isToggled;
      this.submitButtonOptions = this.options.submitButtonOptions;
    },

    render: function() {

      var markup = this.getTemplate(jstSubmitToggler, {
        isEnabled: this.isToggled,
        submitButtonOptions: _.extend(this.submitButtonOptions, {
          'class' : 'submit-toggler-submit',
          element: 'button'
        }),
        translations: {
          tooltip: t('Submit comments by pressing Enter #submit-toggler')
        }
      });

      this.elm.html(markup);

      this.elmBox = this.elm.find('.submit-toggle-box');
      this.elmToggle = this.elm.find('.submit-toggler-toggle');
      this.elmSubmit = this.elm.find('.submit-toggler-submit');

      this.refresh();
    },

    onSubmitButtonClicked: function(elmTarget, e) {
      this.trigger('submitToggler:submitTriggered', this.elm);
    },

    restoreButton: function() {
      podioUI.restoreButtonWithLoader(this.elmSubmit);
    },

    disableButton: function() {
      podioUI.disableButtonWithLoader(this.elmSubmit);
    },

    refresh: function() {
      this.update(false);
    },

    update: function(shouldAnimate) {

      var dfd = new $.Deferred();
      var spacing = parseInt(this.elmToggle.css('marginRight'), 10);
      var inputWidth = this.isToggled ? this.elmSubmit.outerWidth() + spacing * 2 : 0;

      // Transition
      if (shouldAnimate) {
        this.elmBox.one(podioBrowser.cssTransitionEndEvent, dfd.resolve);
      } else {
        dfd.resolve();
      }

      this.elmBox.toggleClass('animate', shouldAnimate);

      this.elm.find('.box').css({
        'left': inputWidth + 'px'
      });

      return dfd;

    },

    onSubmitToggleChanged: function() {

      var self = this;

      tooltips.hideAll();

      this.isToggled = this.elmToggle.find('input').is(':checked');

      var elmToggleBox = this.elmToggle.parents('.submit-toggle-box');

      // UI
      var elmToggleIcon = this.elmToggle.find('.toggle-icon');
      elmToggleIcon.toggleClass('icon-16-green-enter', this.isToggled);
      elmToggleIcon.toggleClass('icon-16-black-enter', !this.isToggled);

      // Animate position change
      var dfd = this.update(true);

      // Data
      this.options.isToggled = this.isToggled;

      // Event
      dfd.done(function() {
        self.trigger('submitToggler:toggleChanged', self.isToggled, self.elm);
      });

    }

  });


});

